import { create } from 'zustand';
import type { Turn } from './conversation';

type ReportChats = {
  /** One conversation per report, kept for this session so it is still there on coming back to the report. */
  byReport: Record<string, Turn[]>;
  add: (reportId: string, turn: Turn) => void;
  update: (reportId: string, turnId: string, fn: (t: Turn) => Turn) => void;
};

export const useReportChatStore = create<ReportChats>()((set) => ({
  byReport: {},
  add: (reportId, turn) => {
    set((s) => ({ byReport: { ...s.byReport, [reportId]: [...(s.byReport[reportId] ?? []), turn] } }));
  },
  update: (reportId, turnId, fn) => {
    set((s) => ({ byReport: { ...s.byReport, [reportId]: (s.byReport[reportId] ?? []).map((t) => (t.id === turnId ? fn(t) : t)) } }));
  },
}));
